import React, { useState, useEffect, type ReactNode } from 'react';

interface LazyModuleProps {
    children: ReactNode;
}

/**
 * Defers rendering children until after the initial paint.
 * The hero section renders immediately; everything wrapped in LazyModule
 * renders once the browser is idle, so it's ready before the user scrolls.
 */
const LazyModule: React.FC<LazyModuleProps> = ({ children }) => {
    const [ready, setReady] = useState(false);

    useEffect(() => {
        if ('requestIdleCallback' in window) {
            const id = requestIdleCallback(() => setReady(true));
            return () => cancelIdleCallback(id);
        }
        // Fallback for Safari
        const id = setTimeout(() => setReady(true), 1);
        return () => clearTimeout(id);
    }, []);

    if (!ready) return null;

    return <>{children}</>;
};

export default LazyModule;
